import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="presence-assignment"
export default class extends Controller {

  static targets = ["userSelect", "overwritePresences", "overwriteAbsences", "submit"]
  
  get formData() {
    return new FormData(this.element)
  }

  get user() {
    const userId = this.formData.get("user_id")
    const option = this.userSelectTarget.querySelector(`option[value="${userId}"]`)
    return option?.text
  }

  get daysOfWeek() {
    return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }

  get daysSelected() {
    return this.formData.getAll("days[]")
  }

  get periodText() {
    const period = this.formData.get("period")
    if (period === "am") { return "matin" }
    if (period === "pm") { return "après-midi" }
    return "journée"
  }

  get startDate() {
    return this.formData.get("start_date")
  }
  
  get endDate() {
    return this.formData.get("end_date")
  }

  get formValid() {
    return this.daysSelected.length > 0 && this.startDate && this.endDate && this.formData.get("user_id")
  }

  onInputChange(event) {
    this.updateButtonStatus()
    if (event.target.name === "method") { 
      this.updateFormAction()
      this.updateOverwiteStatus()
    }
    if (event.target.name === "mode") {
      this.updateFormAction()
    }
  }
  
  updateButtonStatus() {
    this.submitTarget.disabled = !this.formValid
    const verb = this.formData.get("method") === "add" ? "créer" : "supprimer"
    const objects = this.formData.get("mode") === "presence" ? "présences" : "absences"
    const days = this.daysSelected.map(index => this.daysOfWeek[index]).join(", ")
    const startToday = this.startDate === new Date().toLocaleDateString("fr") // this.startDate has format dd/mm/yyyy
    const startDateText = `à partir de ${startToday ? "aujourd'hui" : this.startDate}`
    const confirmation = `Etês-vous sûr de vouloir ${verb} des ${objects} (${this.periodText}) pour ${this.user} pour les ${days} jusqu'au ${this.endDate} (${startDateText}) ?`
    this.submitTarget.setAttribute("data-turbo-confirm", confirmation)
  }

  updateFormAction() {
    const mode = this.formData.get("mode")
    const method = this.formData.get("method") === "add" ? "create" : "destroy"
    const action = this.element.getAttribute(`data-${method}-${mode}-action`)
    this.element.setAttribute("action", action)
  }

  updateOverwiteStatus() {
    const disabled = this.formData.get("method") === "remove"
    const disabledClasses = ["opacity-60", "cursor-not-allowed"]
    this.overwriteCheckboxes.forEach((checkbox) => {
      if (disabled) {
        checkbox.checked = false
        checkbox.disabled = true
        checkbox.parentElement.classList.add(...disabledClasses)
      } else {
        checkbox.disabled = false
        checkbox.parentElement.classList.remove(...disabledClasses)
      }
    })
  }

  get overwriteCheckboxes() {
    const targets = []
    if (this.hasOverwritePresencesTarget) { targets.push(this.overwritePresencesTarget) }
    if (this.hasOverwriteAbsencesTarget) { targets.push(this.overwriteAbsencesTarget) }
    return targets
  }
  
}
